module.exports = __webpack_public_path__ + "static/media/logo_esn_small_nl.ff1c362c.svg";